import templates from './effectTemplates.json'

export const GSPLAT_EFFECT_TEMPLATES = templates as readonly unknown[]
